// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nfieldset[data-v-57282a8e] {\n  border-color: var(--v-grey-darken2);\n  border-radius: 5px;\n  margin-bottom: 12px;\n  padding: 4px;\n}\nlegend[data-v-57282a8e] {\n  padding: 3px 12px;\n}\n.side-legend[data-v-57282a8e] {\n  position: absolute;\n  right: 20px;\n  top: -30px;\n  background-color: white;\n  padding: 0px 8px;\n  height: 28px;\n  border: 1px solid grey;\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
